/** CGU intégrales (batiweb, route /cgu). */
export const BATIKAL_CGU_URL = 'https://app.batikal-app.com/cgu'

/** Politique de confidentialité (batiweb, route /privacy). */
export const BATIKAL_PRIVACY_URL = 'https://app.batikal-app.com/privacy'
